import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/header/header';
import Home from './Pages/Home/Home';
import About from './Pages/About/About';
import Contact from './Pages/ContactUs/ContactUs';
import Services from './Pages/OurServices/OurServices';
import Partners from './Pages/OurPartners/OurPartners';
import Footer from './components/footer/footer';

import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/our-services" element={<Services />} />
          <Route path="/our-partners" element={<Partners />} /> 
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;